import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GiftUnlockPreviewMode } from '../../gift-unlock.component';
import { BUTTON_APPEARANCE_OPTIONS, DropdownOption } from '../../../../shared/config/extension-ui-options';

@Component({
  selector: 'gift-unlock-gift-message',
  templateUrl: './gift-unlock-gift-message.component.html',
  styleUrls: ['./gift-unlock-gift-message.component.scss'],
  standalone: false,
})
export class GiftUnlockGiftMessageComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() displayDesignConfigurationSections: boolean;
  @Input() activePreviewMode: GiftUnlockPreviewMode;
  @Input() defaultIconUrl: string;

  @Output() previewToggle = new EventEmitter<void>();

  PreviewMode = GiftUnlockPreviewMode;

  readonly buttonAppearanceOptions: DropdownOption[] = BUTTON_APPEARANCE_OPTIONS;
}
